import { compose, get } from 'lodash/fp';
import { createSelector } from 'reselect';
import moduleSelector from '../selector';
import { SNACKBARS_MODULE_NAME } from '../constants';

const getSnackbars = createSelector(moduleSelector, (state) => state[SNACKBARS_MODULE_NAME]);

export const isUpdateSnackbarVisible = compose(get('updateVisible'), getSnackbars);
